import { useQuery } from "@tanstack/react-query";
import type {
  ReleaseNotesResult,
  ReleaseNotesScope,
  ReleasePoint,
} from "@insights/contracts";
import { api } from "../../../api";

export function useReleaseNotesScopes(workspaceId: string | undefined) {
  return useQuery({
    enabled: Boolean(workspaceId),
    queryKey: ["release-notes-scopes", workspaceId],
    queryFn: () =>
      api<ReleaseNotesScope[]>(`/${workspaceId}/builds/release-notes/scopes`),
  });
}

export function useReleasePoints(
  workspaceId: string | undefined,
  scope: ReleaseNotesScope | undefined,
) {
  return useQuery({
    enabled: Boolean(workspaceId && scope),
    queryKey: [
      "release-points",
      workspaceId,
      scope?.repository,
      scope?.profile,
    ],
    queryFn: () => {
      const query = new URLSearchParams({
        repository: scope?.repository ?? "",
        profile: scope?.profile ?? "",
      });

      return api<ReleasePoint[]>(
        `/${workspaceId}/builds/release-notes/points?${query.toString()}`,
      );
    },
  });
}

export function useReleaseNotes(
  workspaceId: string | undefined,
  scope: ReleaseNotesScope | undefined,
  fromPointId: string | undefined,
  toPointId: string | undefined,
) {
  return useQuery({
    enabled: Boolean(workspaceId && scope && fromPointId && toPointId),
    queryKey: [
      "release-notes",
      workspaceId,
      scope?.repository,
      scope?.profile,
      fromPointId,
      toPointId,
    ],
    queryFn: () => {
      const query = new URLSearchParams({
        repository: scope?.repository ?? "",
        profile: scope?.profile ?? "",
        from: fromPointId ?? "",
        to: toPointId ?? "",
      });

      return api<ReleaseNotesResult>(
        `/${workspaceId}/builds/release-notes?${query.toString()}`,
      );
    },
  });
}
